import { Routes, Route } from "react-router-dom";
import { GenerateTermList } from "./list";
import { CreateTerm } from "./create";
import { ViewTerm } from "./view";
export default function GenerateTermRoutes() {
  return (
    <Routes>
      <Route path="/" element={<GenerateTermList />} />
      <Route path="/create" element={<CreateTerm />} />
      <Route path="/:id" element={<CreateTerm />} />
      <Route path="/visualizar/:id" element={<ViewTerm />} />
    </Routes>
  );
}
